module.exports = __webpack_public_path__ + "img/document-accept.8b782dd4.svg";